import { styled, Box } from "@mui/material";

export const StudentsBox = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  rowGap: "0.5rem",
  columnGap: "1rem",
}));
